import React from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';

import { IMaskInput } from "react-imask"

import styles from './../style/ConsultationFormF.module.scss';

class ConsultationForm extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      agreed: true,
      formData: {
        name: '',
        phone: ''
      },
      errors: {},
      isSubmitting: false,
      submitStatus: null
    };
    
    this.toggleAgreement = this.toggleAgreement.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }
  
  toggleAgreement() {
    this.setState(prevState => {
      const newErrors = { ...prevState.errors };
      if (newErrors.agreed) {
        delete newErrors.agreed;
      }
      
      return {
        agreed: !prevState.agreed,
        errors: newErrors
      };
    });
  }
  
  handleFormChange(e) {
    const { name, value } = e.target;
    
    this.setState(prevState => {
      const newErrors = { ...prevState.errors };
      if (newErrors[name]) {
        delete newErrors[name];
      }
      
      return {
        formData: {
          ...prevState.formData,
          [name]: value
        },
        errors: newErrors
      };
    });
  }
  
  validateForm() {
    const { formData, agreed } = this.state;
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Пожалуйста, укажите ваше имя';
    }
    
    if (!formData.phone.trim()) {
      newErrors.phone = 'Пожалуйста, укажите ваш телефон';
    } else if (!/^[\d\s()+.-]+$/.test(formData.phone)) {
      newErrors.phone = 'Введите корректный номер телефона';
    }
    
    if (!agreed) {
      newErrors.agreed = 'Необходимо согласие с политикой конфиденциальности';
    }
    
    this.setState({ errors: newErrors });
    return Object.keys(newErrors).length === 0;
  }
  
  async handleFormSubmit(e) {
    e.preventDefault();
    
    if (!this.validateForm()) return;
    
    this.setState({
      isSubmitting: true,
      submitStatus: null
    });

    const main = this,
    baseURL = window.location.protocol + "//" + window.location.hostname
    
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'feedback_form',
      'form': 'Консультация',
      'name': this.state.formData?.name,
      'phone': this.state.formData?.phone,
      'json': JSON.stringify( this.state.formData )
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.result ) {
        main.setState({
          submitStatus: 'success',
          formData: { name: '', phone: '' }
        });
        setTimeout(() => { window.location.href = `${baseURL}/spasibo` }, 2000)
      } else {
        main.setState({ submitStatus: 'error' });
      }
    }).catch(error => {
      // Обработка ошибок, если нужно
      console.error('Error sending form:', error)
      main.setState({ submitStatus: 'error' });
    }).finally(() => {
      // В любом случае снимаем состояние отправки
      main.setState({ isSubmitting: false });
    })
  }

  CheckIcon = ({ checked }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z" fill={"white"}/>
      {checked && (
        <path d="M5.8125 8.99945L7.935 11.122L12.1875 6.87695" stroke="#19AB4B" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
      )}
    </svg>
  );

  NameIcon = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.00016 7.00033C8.61099 7.00033 9.91683 5.69449 9.91683 4.08366C9.91683 2.47283 8.61099 1.16699 7.00016 1.16699C5.38933 1.16699 4.0835 2.47283 4.0835 4.08366C4.0835 5.69449 5.38933 7.00033 7.00016 7.00033Z" stroke="white" strokeOpacity="0.4" strokeWidth="0.758333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.0109 12.8333C12.0109 10.5758 9.76509 8.75 7.00009 8.75C4.23509 8.75 1.98926 10.5758 1.98926 12.8333" stroke="white" strokeOpacity="0.4" strokeWidth="0.758333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  PhoneIconInput = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.8157 10.6928C12.8157 10.9028 12.769 11.1187 12.6698 11.3287C12.5707 11.5387 12.4423 11.737 12.2732 11.9237C11.9873 12.2387 11.6723 12.4662 11.3165 12.612C10.9665 12.7578 10.5873 12.8337 10.179 12.8337C9.584 12.8337 8.94817 12.6937 8.27734 12.4078C7.6065 12.122 6.93567 11.737 6.27067 11.2528C5.59984 10.7628 4.964 10.2203 4.35734 9.61949C3.7565 9.01283 3.214 8.37699 2.72984 7.71199C2.2515 7.04699 1.8665 6.38199 1.5865 5.72283C1.3065 5.05783 1.1665 4.42199 1.1665 3.81533C1.1665 3.41866 1.2365 3.03949 1.3765 2.68949C1.5165 2.33366 1.73817 2.00699 2.04734 1.71533C2.42067 1.34783 2.829 1.16699 3.26067 1.16699C3.424 1.16699 3.58734 1.20199 3.73317 1.27199C3.88484 1.34199 4.019 1.44699 4.124 1.59866L5.47734 3.50616C5.58234 3.65199 5.65817 3.78616 5.71067 3.91449C5.76317 4.03699 5.79234 4.15949 5.79234 4.27033C5.79234 4.41033 5.7515 4.55033 5.66984 4.68449C5.594 4.81866 5.48317 4.95866 5.34317 5.09866L4.89984 5.55949C4.83567 5.62366 4.8065 5.69949 4.8065 5.79283C4.8065 5.83949 4.81234 5.88033 4.824 5.92699C4.8415 5.97366 4.859 6.00866 4.87067 6.04366C4.97567 6.23616 5.1565 6.48699 5.41317 6.79033C5.67567 7.09366 5.95567 7.40283 6.259 7.71199C6.574 8.02116 6.87734 8.30699 7.1865 8.56949C7.48984 8.82616 7.74067 9.00116 7.939 9.10616C7.96817 9.11783 8.00317 9.13533 8.044 9.15283C8.09067 9.17033 8.13734 9.17616 8.18984 9.17616C8.289 9.17616 8.36484 9.14116 8.429 9.07699L8.87234 8.63949C9.01817 8.49366 9.15817 8.38283 9.29234 8.31283C9.4265 8.23116 9.56067 8.19033 9.7065 8.19033C9.81734 8.19033 9.934 8.21366 10.0623 8.26616C10.1907 8.31866 10.3248 8.39449 10.4707 8.49366L12.4015 9.86449C12.5532 9.96949 12.6582 10.092 12.7223 10.2378C12.7807 10.3837 12.8157 10.5295 12.8157 10.6928Z" stroke="white" strokeOpacity="0.4" strokeWidth="0.758333" strokeMiterlimit="10"/>
      <path d="M10.7917 5.25065C10.7917 4.90065 10.5175 4.36398 10.1092 3.92648C9.73583 3.52398 9.24 3.20898 8.75 3.20898" stroke="white" strokeOpacity="0.4" strokeWidth="0.758333" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.8333 5.25033C12.8333 2.99283 11.0075 1.16699 8.75 1.16699" stroke="white" strokeOpacity="0.4" strokeWidth="0.758333" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  
  render() {
    const {
      agreed,
      formData,
      errors,
      isSubmitting,
      submitStatus
    } = this.state;

    return (
      <div className={styles.formContainer}>
        <h3 className={styles.formTitle}>Нужна консультация?</h3>
        <p className={styles.formText}>Оставьте заявку и мы свяжемся с Вами оперативно</p>
        
        {submitStatus === 'success' && (
          <Alert variant="success" className={styles.alert}>
            Спасибо! Ваша заявка отправлена. Мы свяжемся с вами в ближайшее время.
          </Alert>
        )}
        
        {submitStatus === 'error' && (
          <Alert variant="danger" className={styles.alert}>
            Произошла ошибка при отправке формы. Пожалуйста, попробуйте еще раз.
          </Alert>
        )}
        
        <Form onSubmit={this.handleFormSubmit} className={styles.consultationForm}>
          <div className="row">
            <div className="col-md-6">
              <Form.Group className={styles.formGroup}>
                <div className={styles.inputWrapper}>
                  <span className={styles.inputIcon}>
                    <this.NameIcon />
                  </span>
                  <Form.Control 
                    type="text" 
                    name="name"
                    required
                    value={formData.name}
                    placeholder="Имя" 
                    className={`${styles.formInput} ${errors.name ? styles.inputError : ''}`}
                    onChange={this.handleFormChange}
                    key="name-input"
                  />
                </div>
              </Form.Group>
              
              <Form.Group className={styles.formGroup}>
                <div className={styles.inputWrapper}>
                  <span className={styles.inputIcon}>
                    <this.PhoneIconInput />
                  </span>
                  <Form.Control
                    name="phone"
                    required
                    onChange={this.handleFormChange}
                    as={IMaskInput}
                    mask="+{7} (000) 000-00-00"
                    lazy={true}
                    type="tel"
                    placeholder="+7 (999)-999-99-99" 
                    value={formData.phone}
                    className={`${styles.formInput} ${errors.phone ? styles.inputError : ''}`}
                    key="phone-input"
                  />
                </div>
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Button 
                type="submit" 
                className={styles.submitButton}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Отправка...' : 'Отправить'}
              </Button>
              
              <div className={styles.agreement} onClick={this.toggleAgreement}>
                <div className={styles.checkIcon}>
                  <this.CheckIcon checked={agreed} />
                </div>
                <span className={styles.agreementText}>
                  Нажимая на кнопку "Отправить", вы соглашаетесь с <a className='text-white' target="_blank" href="/privacy">политикой конфиденциальности</a>
                </span>
              </div>
              {errors.agreed && <div className={styles.errorMessage}>{errors.agreed}</div>}
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default ConsultationForm;